import { Content } from 'shared/components/Content';
import { WelcomeContainer } from '../WelcomeContainer';
import { GuideList } from 'shared/components/GuideList';

export const ContentContainer: React.FC = () => {
  return <Content welcome={<WelcomeContainer />} guide={<GuideList />} />;
};
